import React, { FC, Fragment, useCallback } from 'react'
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Text,
  Stack,
} from '@chakra-ui/react'

import { Empty, Loader, Pagination } from 'components'
import { capitalizeString } from 'utils/transforms/string'
import CustomFormCommonEntityFilterTags from 'components/tools/CustomForm/commonComponents/CustomFormCommonEntityFilterTags'
import CustomFormEntityCardToSelect from './components/CustomFormEntityCardToSelect'
import { useCustomFormCommonEntityPropsManager } from '../../contexts/CustomFormCommonEntityPropsManager/Provider'

type Props = {
  onClose: () => void
}

const SelectEntityOnCustomForm: FC<Props> = ({ onClose }) => {
  const {
    currentEntity,
    invalidEntity,
    pagination,
    setPagination,
    totalEntities,
    loadingEntities,
    entities,
    setView,
    filter,
    setFilter,
  } = useCustomFormCommonEntityPropsManager()

  const handleChangePage = useCallback((nextPage: number) => {
    setPagination((oldPagination) => {
      return { ...oldPagination, page: nextPage }
    })
  }, [])

  const handleChangeLimit = useCallback((limit: number) => {
    setPagination((oldPagination) => {
      return { ...oldPagination, limit, page: pagination.page }
    })
  }, [])

  return (
    <>
      <DrawerCloseButton />

      <DrawerHeader>
        <Text>{capitalizeString(currentEntity.labelPlural)} disponíveis</Text>
        <Heading color="primary">Selecionar {currentEntity.label}</Heading>
      </DrawerHeader>

      <DrawerBody overflowY="auto">
        <Stack>
          <CustomFormCommonEntityFilterTags entityFilter={filter} setEntityFilter={setFilter} />

          {loadingEntities ? (
            <Loader text={`Carregando ${currentEntity.labelPlural} disponíveis`} />
          ) : (
            <Fragment>
              {invalidEntity ? (
                <Empty illustration="EmptyDrawer" title={`Não foi encontrado nenhum(a) ${currentEntity.label}`}>
                  <Button onClick={() => setView('SEARCH_ENTITY')}>Pesquisar novamente</Button>
                </Empty>
              ) : (
                <Fragment>
                  {entities.length > 0 ? (
                    <Stack>
                      {entities.map((entity) => (
                        <CustomFormEntityCardToSelect key={entity.id} entity={entity} onClose={onClose} />
                      ))}

                      <Pagination
                        totalItems={totalEntities}
                        currentPage={pagination.page}
                        limit={pagination.limit}
                        onChangePage={handleChangePage}
                        onChangeLimit={handleChangeLimit}
                      />
                    </Stack>
                  ) : (
                    <Empty
                      title={`Nenhum(a) ${currentEntity.label} encontrada`}
                      description="Sua busca não retornou registros"
                    />
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={() => setView('SEARCH_ENTITY')}>
          Voltar
        </Button>

        <Button onClick={onClose}>Concluir</Button>
      </DrawerFooter>
    </>
  )
}

export default SelectEntityOnCustomForm
